import { render, staticRenderFns } from "./EnrollmentView.vue?vue&type=template&id=39521932&scoped=true&"
import script from "./EnrollmentView.vue?vue&type=script&lang=js&"
export * from "./EnrollmentView.vue?vue&type=script&lang=js&"
import style0 from "./EnrollmentView.vue?vue&type=style&index=0&id=39521932&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39521932",
  null
  
)

export default component.exports